module.exports = __webpack_public_path__ + "img/scene5-2.7aa2bc2c.jpg";